import { render, staticRenderFns } from "./SingleOptionFilterComp.vue?vue&type=template&id=66818698&"
import script from "./SingleOptionFilterComp.vue?vue&type=script&lang=js&"
export * from "./SingleOptionFilterComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports